export default {
  URL: `${window.location.protocol}//${window.location.host}`,
  LOGIN_URL: (process.env.REACT_APP_NEO_ADMIN_URL ?? 'https://neoadmin.neored.com') + '/login',
  LOGOUT_URL: (process.env.REACT_APP_NEO_ADMIN_URL ?? 'https://neoadmin.neored.com') + '/logout',
};